import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table, TableBody, TableRow, TableCell, TablePagination } from '@material-ui/core';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import FormatDate from '../FormatDate';
import { withTranslation } from 'react-i18next';

class ReportsList extends Component {
    constructor(props) {
        super(props);

        this.color = this.props.color || '#000';
    }

    handleChangeRowsPerPage(event) {
        this.props.onReportsToDisplayChange(event.target.value, true);
    }

    render() {
        const { reports, restaurant, totalReportsCount, page, rowsPerPage } = this.props;

        if (!reports) {
            return null;
        }

        return (
            <div>
                <Table>
                    <TableBody>
                        {reports.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((report, i) => (
                            <TableRow
                                key={i}
                                component={Link}
                                to={{
                                    pathname: `/restaurants/${restaurant ? restaurant.id : report.restaurant.id}/reports/${report.id}`,
                                    scope: { report }
                                }}
                                style={{ textDecoration: 'none' }}
                            >
                                <TableCell style={{ color: this.color }}>{FormatDate(report.date)}</TableCell>
                                <TableCell style={{ color: this.color }}>{this.props.t('Kirjauslomake')}</TableCell>
                                <TableCell style={{ color: this.color }}>{restaurant ? restaurant.name : report.restaurant.name}</TableCell>
                                <TableCell style={{ color: this.color }}>{report.reporter}</TableCell>
                                <TableCell style={{ textAlign: 'right' }}>
                                    <KeyboardArrowRight />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={totalReportsCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': this.props.t('Edellinen sivu'),
                    }}
                    nextIconButtonProps={{
                        'aria-label': this.props.t('Seuraava sivu'),
                    }}
                    labelRowsPerPage={this.props.t('Rivejä sivulla')}
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`}
                    onChangePage={(e, page) => {
                        if (e) {
                            this.props.changePageNumber(page);
                        }
                    }}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage.bind(this)}
                />
            </div>
        );
    }
}

export default withTranslation()(ReportsList);



// WEBPACK FOOTER //
// ./resources/assets/js/components/ReportsList.js